export enum DiaSemana {
  SEGUNDA = 0,
  TERCA = 1,
  QUARTA = 2,
  QUINTA = 3,
  SEXTA = 4,
  SABADO = 5,
  DOMINGO = 6
}

export interface HorarioFuncionamento {
  dias: DiaSemana[];
  horaInicio: string;
  horaFim: string;
}

export const DIA_SEMANA_LABELS: Record<DiaSemana, string> = {
  [DiaSemana.SEGUNDA]: 'Seg',
  [DiaSemana.TERCA]: 'Ter',
  [DiaSemana.QUARTA]: 'Qua',
  [DiaSemana.QUINTA]: 'Qui',
  [DiaSemana.SEXTA]: 'Sex',
  [DiaSemana.SABADO]: 'Sab',
  [DiaSemana.DOMINGO]: 'Dom'
};

export const DIAS_SEMANA: DiaSemana[] = [
  DiaSemana.SEGUNDA,
  DiaSemana.TERCA,
  DiaSemana.QUARTA,
  DiaSemana.QUINTA,
  DiaSemana.SEXTA,
  DiaSemana.SABADO,
  DiaSemana.DOMINGO
];

const NOMES_DIA_SEMANA_API: string[] = ['SEGUNDA', 'TERCA', 'QUARTA', 'QUINTA', 'SEXTA', 'SABADO', 'DOMINGO'];

export function diaSemanaDaApi(valor: DiaSemana | string): DiaSemana {
  if (typeof valor === 'number') {
    return valor;
  }
  const indice = NOMES_DIA_SEMANA_API.indexOf(valor);
  return indice === -1 ? DiaSemana.SEGUNDA : indice;
}

export function diaSemanaParaApi(dia: DiaSemana): string {
  return NOMES_DIA_SEMANA_API[dia];
}
